import React, { Component } from 'react'
import styled from 'styled-components'
import { Button } from 'advenio-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import R from 'ramda'
import PropTypes from 'prop-types' //eslint-disable-line

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  width: 100%;
  height: 100%;
`
const HeaderTitle = styled.div`
  flex: 1;
  height: 80px;
  border-bottom: solid 1px;
  border-bottom-color: #CCCCCC;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin-bottom: 10px;
`
const ExtraChargeContainer = styled.div`
  flex-direction: column;
  flex-shrink: 0;
  flex: 1;

  padding: 5px;
  box-sizing: border-box;

  width: 100%;
  overflow-y: auto;

  @media (min-width: 767px) {
    max-height: 500px;
  }
`

const NameHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 8px;
`
const Close = styled.div`
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
`
const Profile = styled.div`
  background-image: ${props => props.profile ? 'url(' + props.profile + ')' : ''};
  background-size: cover;
  background-position: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border:  solid #CCCCCC 1px;
  margin-right: 4px;
`
const NameSpan = styled.span`
  color: #979797;
`
const Img = styled.img`
  padding: 16px;
  cursor: pointer;
`
const SaveContainer = styled.div`
 width: 100%;
 height: 60px;
 background-color: #fff;
 justify-content:space-between;
 align-items: center;
 display: flex;
`
export const IconsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
export const Check = styled.img`
    width: 20px;
    height: 20px;
    margin-right: 10px;
`
export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 30px;
  padding: 16px;
  cursor: pointer;
`
const Charge = styled.div`
  height: 50px;
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  background-color: ${props => props.selected ? '#3b99fc' : ''};
  margin-bottom: 5px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border-radius: 3%;
  border: solid 1px #CCCCCC;
`
const Buttons = styled.button`
  color: ${props => props.selected ? '#FFF' : ''};
  background-color: transparent;
  padding: 8px 20px;
  height: 100%;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
`

let consumable_category = []
let extra_charges = []

class ExtraCharge extends Component {
  constructor(props) {
    super(props)
    consumable_category = this.props.consumables_categories.filter(category => category.name === 'Foods')
    extra_charges = R.clone(this.props.consumables.filter(charge => charge.category_id === consumable_category[0].id))
    for (let i = 0; i < extra_charges.length; i++) {
      extra_charges[i].selected = false
    }
    //const extraCharge = [{ id: 1, name: 'cereal', price: '20', selected: false }, { id: 2, name: 'cereal', price: '20', selected: false }, { id: 3, name: 'cereal', price: '20', selected: false }, { id: 4, name: 'cereal', price: '20', selected: false }, { id: 5, name: 'cereal', price: '20', selected: false }]
    this.state = {
      extraCharge: extra_charges,
      isComplete: false
    }
  }

  onClick = (e) => {
    const id = e.target.id
    const aux = []
    const newState = { ...this.state }
    for (let i = 0; i < newState.extraCharge.length; i++) {
      if (newState.extraCharge[i].id == id) {
        newState.extraCharge[i].selected = !newState.extraCharge[i].selected
      }
      if (newState.extraCharge[i].selected) {
        aux.push(true)
      } else {
        aux.push(false)
      }
    }
    newState.isComplete = aux.indexOf(true) >= 0
    this.setState(newState)
  }

  closeModal = () => {
    this.props.closeModal()
  }

  reset = () => {
    const newState = { ...this.state }
    for (let i = 0; i < newState.extraCharge.length; i++) {
      newState.extraCharge[i].selected = false
    }
    this.setState(newState)
  }

  addCharge = () => {
    let infoToSend = []
    const extras = []
    for (let i = 0; i < this.state.extraCharge.length; i++) {
      if (this.state.extraCharge[i].selected) {
        if (this.props.group) {
          extras.push(this.state.extraCharge[i])
        } else {
          extras.push(this.state.extraCharge[i].id)
        }
      }
    }
    infoToSend = extras
    if (this.props.group) {
      this.props.extras(infoToSend, this.props.child.id)
      this.props.closeModal()
    } else {
      const nextState = { ...this.props.info }
      nextState['extras'] = infoToSend
      this.props.setExtraData(nextState)
      this.props.goToView('confirm', '',this.props.category)
    }
  }


  render() {
    return (
      <Container>
        <ExtraChargeContainer>
          {
            this.state.extraCharge.map((currentValue, index, array) => {
              return (
                <Charge key={index} selected={currentValue.selected} >
                  <Input
                    ref={(input) => this.clickItem = input}
                    onClick={this.onClick}
                    id={currentValue.id}
                    type="radio"
                  />
                    <Buttons onClick={() => this.clickItem.click()} selected={currentValue.selected}>
                        <Check src={currentValue.selected ? "/assets/check_mark.svg" : "/assets/blank_check_mark.svg" }/>
                        {currentValue.consumable}
                    </Buttons>
                </Charge>
              )
            })
          }
        </ExtraChargeContainer>
        <SaveContainer>
          <Button
            small
            transparent
            onClick={this.reset}
          >
          Borrar
          </Button>
          <Button
            small
            style={{ backgroundColor: '#75B756', color: '#FFF' }}
            onClick={this.addCharge}
          >
            {this.state.isComplete ? 'Continuar' : 'No hubo'}
          </Button>
        </SaveContainer>
      </Container>
    )
  }
}

ExtraCharge.propTypes = {
  goToView: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  setExtraData: PropTypes.func.isRequired,
  info: PropTypes.object,
}

ExtraCharge.defaultProps = {
  info: {},
}

const mapStateToProps = state => ({
  consumables: state.consumables.get.results,
  consumables_categories: state.consumables_categories.get.results,
})

const mapDispatchToProps = dispatch => ({

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExtraCharge))



// WEBPACK FOOTER //
// ./src/Components/Activity/ExtraCharge.jsx